import { render } from "./DuplicateReferenceModal.vue?vue&type=template&id=122ce1f0"
import script from "./DuplicateReferenceModal.vue?vue&type=script&lang=js"
export * from "./DuplicateReferenceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__